import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 9/12;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 9 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Docs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Doc" transform="translate(-437.000000, -388.000000)">
                <g id="Group-10" transform="translate(421.000000, 180.000000)">
                    <g id="Group-7" transform="translate(11.000000, 206.000000)">
                        <g id="Strike" transform="translate(5.000000, 0.000000)">
                            <path d="M0.471679688,10.2519531 L1.98242188,10.2519531 C2.09179688,11.2294922 3.04199219,11.8720703 4.34082031,11.8720703 C5.58496094,11.8720703 6.48046875,11.2294922 6.48046875,10.3476562 C6.48046875,9.58203125 5.94042969,9.12402344 4.66210938,8.80957031 L3.38378906,8.50195312 C1.57226562,8.06445312 0.731445312,7.21679688 0.731445312,5.84277344 C0.731445312,4.140625 2.21484375,2.97167969 4.3203125,2.97167969 C6.40527344,2.97167969 7.83398438,4.140625 7.88183594,5.84277344 L6.39160156,5.84277344 C6.30273438,4.85839844 5.48925781,4.26367188 4.29980469,4.26367188 C3.11035156,4.26367188 2.296875,4.86523438 2.296875,5.74023438 C2.296875,6.4375 2.81640625,6.84765625 4.08789062,7.16210938 L5.17480469,7.42871094 C7.19824219,7.90722656 8.0390625,8.72070312 8.0390625,10.1630859 C8.0390625,12.0087891 6.56933594,13.1640625 4.23144531,13.1640625 C2.04394531,13.1640625 0.567382812,12.0361328 0.471679688,10.2519531 Z" id="S" fill={color}></path>
                            <path d="M1,8.5 L8,8.5" id="Line-7" stroke="#02BDAD" strokeLinecap="square"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconFormatStrike extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
